import { render, staticRenderFns } from "./AddendumHistory.vue?vue&type=template&id=7330ec92&scoped=true"
import script from "./AddendumHistory.vue?vue&type=script&lang=js"
export * from "./AddendumHistory.vue?vue&type=script&lang=js"
import style0 from "./AddendumHistory.vue?vue&type=style&index=0&id=7330ec92&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7330ec92",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\s\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7330ec92')) {
      api.createRecord('7330ec92', component.options)
    } else {
      api.reload('7330ec92', component.options)
    }
    module.hot.accept("./AddendumHistory.vue?vue&type=template&id=7330ec92&scoped=true", function () {
      api.rerender('7330ec92', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/infra/bidDocumentation/components/AddendumHistory.vue"
export default component.exports